import { useExperimentBucket } from '@carvana/experiment';
import TagIcon from '@carvana/merch-search/stories/GreatDeal/TagIcon';
import React from 'react';
import { NewPriceIcon } from '@/NewPrice';
import TagId from '~/constants/TagId';
import DeliveryTruckIcon from '~/icons/DeliveryTruckIcon';
import PlugIcon from '~/icons/PlugIcon';

const getSubText = (
  key: string
): {
  subText: string;
  Icon: React.SVGProps<SVGSVGElement>;
  dataQa?: string;
} => {
  switch (key) {
    case 'isFreeDelivery':
      return {
        Icon: <DeliveryTruckIcon />,
        subText: 'Vehicles without shipping fees and available sooner.',
        dataQa: 'free-shipping-copy'
      };
    case TagId.GreatDeal.toString():
      return {
        Icon: <TagIcon />,
        subText:
          'Vehicles priced lower than the Kelley Blue Book® Typical Listing Price.',
        dataQa: 'great-deal-copy'
      };
    case TagId.PriceDrop.toString():
      return {
        Icon: <NewPriceIcon className="blue" />,
        subText:
          'We are always repricing our inventory to make room for new vehicles. Don’t miss out!',
        dataQa: 'price-drop-copy'
      };
    case TagId.EVCredit.toString():
      return {
        Icon: <PlugIcon />,
        subText:
          'Vehicles that may qualify for the Previously-Owned Clean Vehicle tax credit.'
      };
    default:
      return { Icon: <div />, subText: '' };
  }
};

type LabelProps = {
  count: number;
  displayName?: string;
  hideCount?: boolean;
  labelKey: string;
};

const GreatDealsLabel = ({
  count = -1,
  displayName = '',
  hideCount,
  labelKey
}: LabelProps) => {
  const experimentBucket = useExperimentBucket('srch-set-reduction2');
  const showCount = experimentBucket === 'show-zero-counts' && !hideCount;
  const { Icon, subText, dataQa } = getSubText(labelKey);

  return (
    <div className="flex flex-col gap-[6px]">
      <div className="flex font-bold gap-8 items-center leading-[20px] text-[16px]">
        <span>{displayName}</span>
        {Icon}{' '}
        {showCount && count >= 0 ? (
          <span className="!font-bold self-end t-body-xs text-grey-3">
            ({count.toLocaleString()})
          </span>
        ) : null}
      </div>
      <div className="t-body-s text-grey-5" data-qa={dataQa}>
        {subText}
      </div>
    </div>
  );
};

export default GreatDealsLabel;
